const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "animate--zoom-in";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
    elements.forEach((element, index) => {
        if (element.isIntersecting) {
            const elementTarget = element.target;
            if (
                elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
            ) {
                elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
                if (elementTarget.hasAttribute("data-cascade"))
                    elementTarget.setAttribute("style", `--animation-order: ${index};`);
            }
            observer.unobserve(elementTarget);
        } else {
            element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
            element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
        }
    });
}

function initializeScrollAnimationTrigger(
    rootEl = document,
    isDesignModeEvent = false
) {
    const animationTriggerElements = Array.from(
        rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
    );
    if (animationTriggerElements.length === 0) return;

    if (isDesignModeEvent) {
        animationTriggerElements.forEach((element) => {
            element.classList.add("scroll-trigger--design-mode");
        });
        return;
    }

    const observer = new IntersectionObserver(onIntersection, {
        rootMargin: "0px 0px -50px 0px",
    });
    animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const animationTriggerElements = Array.from(
        document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
    );

    if (animationTriggerElements.length === 0) return;

    const scaleAmount = 0.2 / 100;

    animationTriggerElements.forEach((element) => {
        let elementIsVisible = false;
        const observer = new IntersectionObserver((elements) => {
            elements.forEach((entry) => {
                elementIsVisible = entry.isIntersecting;
            });
        });
        observer.observe(element);

        element.style.setProperty(
            "--zoom-in-ratio",
            1 + scaleAmount * percentageSeen(element)
        );

        window.addEventListener(
            "scroll",
            throttle(() => {
                if (!elementIsVisible) return;

                element.style.setProperty(
                    "--zoom-in-ratio",
                    1 + scaleAmount * percentageSeen(element)
                );
            }),
            { passive: true }
        );
    });
}

function percentageSeen(element) {
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const elementPositionY = element.getBoundingClientRect().top + scrollY;
    const elementHeight = element.offsetHeight;

    if (elementPositionY > scrollY + viewportHeight) {
        // If we haven't reached the image yet
        return 0;
    } else if (elementPositionY + elementHeight < scrollY) {
        // If we've completely scrolled past the image
        return 100;
    }

    // When the image is in the viewport
    const distance = scrollY + viewportHeight - elementPositionY;
    let percentage = distance / ((viewportHeight + elementHeight) / 100);
    return Math.round(percentage);
}

window.addEventListener("DOMContentLoaded", () => {
    initializeScrollAnimationTrigger();
    initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) =>
        initializeScrollAnimationTrigger(event.target, true)
    );
    document.addEventListener("shopify:section:reorder", () =>
        initializeScrollAnimationTrigger(document, true)
    );
}

/** mt-image-selector **/
Array.from(document.querySelectorAll(".mt-image-selector__wrapper")).forEach(
    (container) => {
        var selectors = container.querySelectorAll(".mt-image-selector__selector");
        var itemSelects = Array.from(
            container.querySelectorAll(".mt-image-selector__item")
        );

        selectors.forEach((selector) => {
            selector.addEventListener("click", (e) => {
                selectors.forEach((item) => {
                    item.classList.remove("selected");
                });
                e.target.classList.add("selected");
                var val = parseInt(e.target.getAttribute("data-val"));
                itemSelects.forEach((item) => {
                    var curVal = parseInt(item.getAttribute("data-val"));
                    if (val == curVal) {
                        item.classList.remove("unshow");
                    } else {
                        item.classList.add("unshow");
                    }
                });
            });
        });
    }
);
/** mt-image-selector **/

/** mt-text-selector **/
Array.from(document.querySelectorAll(".mt-text-selector__wrapper")).forEach(
    (container) => {
        var selectors = container.querySelectorAll(".mt-text-selector__selector");
        var itemSelects = Array.from(
            container.querySelectorAll(".mt-text-selector__item")
        );
        selectors.forEach((selector) => {
            selector.addEventListener("click", (e) => {
                selectors.forEach((item) => {
                    item.classList.remove("selected");
                });
                e.target.classList.add("selected");
                var val = parseInt(e.target.getAttribute("data-val"));
                itemSelects.forEach((item) => {
                    var curVal = parseInt(item.getAttribute("data-val"));
                    if (val == curVal) {
                        item.classList.remove("hidden");
                        item.classList.remove("unshow");
                    } else {
                        item.classList.add("hidden");
                        item.classList.add("unshow");
                    }
                });
            });
        });
    }
);
/** mt-text-selector **/

/** mt-image-text-icons **/
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach(
    (container) => {
        var selectors = container.querySelectorAll(".mt-image-text-icons__dot");
        var itemSelects = Array.from(
            container.querySelectorAll(".mt-image-text-icons__image")
        );

        selectors.forEach((selector) => {
            selector.addEventListener("click", (e) => {
                selectors.forEach((item) => {
                    item.classList.remove("selected");
                });
                e.target.classList.add("selected");
                var val = parseInt(e.target.getAttribute("data-val"));
                itemSelects.forEach((item) => {
                    var curVal = parseInt(item.getAttribute("data-val"));
                    if (val == curVal) {
                        item.classList.add("blur_show");
                    } else {
                        item.classList.remove("blur_show");
                    }
                });
            });
        });
    }
);
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach(
    (container) => {
        var selectors = container.querySelectorAll(
            ".mt-image-text-icons__icon-item"
        );
        selectors.forEach((selector) => {
            selector.addEventListener("click", (e) => {
                selectors.forEach((item) => {
                    item
                        .querySelector(".mt-image-text-icons__arrow")
                        .classList.remove("selected");
                });
                selector
                    .querySelector(".mt-image-text-icons__arrow")
                    .classList.add("selected");
                var val = parseInt(
                    selector
                        .querySelector(".mt-image-text-icons__arrow")
                        .getAttribute("data-val")
                );
                Array.from(
                    container.querySelectorAll(".mt-image-text-icons__icon-detail")
                ).forEach((item) => {
                    var curVal = parseInt(item.getAttribute("data-val"));
                    if (val == curVal) {
                        item.classList.toggle("scale0");
                    } else {
                        item.classList.add("scale0");
                    }
                });
            });
        });
    }
);
/** mt-image-text-icons **/

/** mt-video-list **/
Array.from(document.querySelectorAll(".mt-video-list_container")).forEach(
    (container) => {
        let btns = container.querySelector(".slider-buttons");
        btns
            .querySelector(".slider-button--prev")
            .addEventListener("click", (e) => {
                selectContent(1);
            });
        btns
            .querySelector(".slider-button--next")
            .addEventListener("click", (e) => {
                selectContent(-1);
            });
        let itemSelects = Array.from(
            container.querySelectorAll(".mt-video-list-item")
        );
        let firstLeft = itemSelects[0].offsetLeft;
        let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
        function selectContent(val) {
            let curLeft = container.querySelector(
                ".mt-video-list-wrapper"
            ).scrollLeft;
            let moveX = (-1 * curLeft) % leftX;

            if (itemSelects != null && itemSelects.length > 1) {
                moveX = (leftX - moveX) * val;
            }
            container.querySelector(".mt-video-list-wrapper").scrollLeft =
                curLeft - moveX;
        }
        if (window.innerWidth > 750) {
            container.querySelector(".mt-video-list-wrapper").scrollLeft = 250;
        }

    }
);
/** mt-video-list **/

/** mt-product-list **/
Array.from(document.querySelectorAll(".mt-product-list__container")).forEach(
    (container) => {
        let btns = container.querySelector(".slider-buttons");
        btns
            .querySelector(".slider-button--prev")
            .addEventListener("click", (e) => {
                selectContent(1);
            });
        btns
            .querySelector(".slider-button--next")
            .addEventListener("click", (e) => {
                selectContent(-1);
            });
        let itemSelects = Array.from(
            container.querySelectorAll(".mt-product-list__item")
        );
        let firstLeft = itemSelects[0].offsetLeft;
        let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
        function selectContent(val) {
            let curLeft = container.querySelector(
                ".mt-product-list__items"
            ).scrollLeft;
            let moveX = (-1 * curLeft) % leftX;

            if (itemSelects != null && itemSelects.length > 1) {
                moveX = (leftX - moveX) * val;
            }
            container.querySelector(".mt-product-list__items").scrollLeft =
                curLeft - moveX;
        }
    }
);
/** mt-product-list **/

/** mt-image-grid **/
Array.from(
    document.querySelectorAll(".mt-image-grid__container .mb_show")
).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    btns.querySelector(".slider-button--prev").addEventListener("click", (e) => {
        selectContent(1);
    });
    btns.querySelector(".slider-button--next").addEventListener("click", (e) => {
        selectContent(-1);
    });
    let itemSelects = Array.from(
        container.querySelectorAll(".mt-image-grid__item")
    );
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
    function selectContent(val) {
        let curLeft = container.querySelector(
            ".mt-image-grid__top-list"
        ).scrollLeft;
        let moveX = (-1 * curLeft) % leftX;

        if (itemSelects != null && itemSelects.length > 1) {
            moveX = (leftX - moveX) * val;
        }
        itemSelects.forEach((itemItem) => {
            container.querySelector(".mt-image-grid__top-list").scrollLeft =
                curLeft - moveX;
        });
    }
});
/** mt-image-grid **/

/** mt-showcase-blogs **/
Array.from(
    document.querySelectorAll(".mt-showcase-blogs__container .mb_show")
).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    btns.querySelector(".slider-button--prev").addEventListener("click", (e) => {
        selectContent(1);
    });
    btns.querySelector(".slider-button--next").addEventListener("click", (e) => {
        selectContent(-1);
    });
    let itemSelects = Array.from(
        container.querySelectorAll(".mt-showcase-blogs__mblog")
    );
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
    function selectContent(val) {
        let curLeft = container.querySelector(
            ".mt-showcase-blogs__mblogs"
        ).scrollLeft;
        let moveX = (-1 * curLeft) % leftX;

        if (itemSelects != null && itemSelects.length > 1) {
            moveX = (leftX - moveX) * val;
        }
        container.querySelector(".mt-showcase-blogs__mblogs").scrollLeft =
            curLeft - moveX;
    }
});
/** mt-showcase-blogs **/

/** mt-slideshow **/
Array.from(document.querySelectorAll(".mt-slideshow__container")).forEach(
    (container) => {
        let dots = container.querySelector(".mt-slideshow__dots");
        let itemSelects = Array.from(
            container.querySelectorAll(".mt-slideshow__item")
        );
        if (dots != null && itemSelects != null) {
            Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
                dot.addEventListener("click", (e) => {
                    let val = parseInt(e.target.getAttribute("data-val"));
                    selectContent(parseInt(val));
                });
            });
            let times = parseInt(
                container.querySelector(".mt_interval_times").innerText
            );
            let maxVal = parseInt(dots.getAttribute("max-val"));
            let curIndex = 1;
            // 自动轮播
            setInterval(function () {
                if (curIndex < maxVal) {
                    curIndex++;
                } else {
                    curIndex = 1;
                }
                selectContent(curIndex);
            }, times * 1000);
            let firstLeft = itemSelects[0].offsetLeft;
            let leftX = 0;
            if (itemSelects.length > 1) {
                leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
            }
            function selectContent(val) {
                let moveX = 0;
                if (itemSelects != null && itemSelects.length > 1) {
                    moveX = firstLeft - leftX * (val - 1);
                }
                container.querySelector(".mt-slideshow__items").style.marginLeft =
                    moveX + "px";
                Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
                    if (parseInt(item.getAttribute("data-val")) == val) {
                        item.classList.add("selected");
                    } else {
                        item.classList.remove("selected");
                    }
                });
                curIndex = val;
            }
        }
    }
);
/** mt-slideshow **/

if (document.querySelectorAll(".popup-close") != null) {
    document.querySelectorAll(".popup-close").forEach((item) => {
        item.addEventListener("click", function (e) {
            item.closest(".popup-wins").classList.add("unshow");
        });
    });
}

if (document.querySelector(".popup_dimensions-container") != null) {
    Array.from(document.querySelectorAll(".popup_dimensions-container")).forEach(
        (container) => {
            container
                .querySelector(".popup_dimensions-open")
                .addEventListener("click", function (e) {
                    document
                        .querySelector(".popup-wins[data-type='popup_dimensions']")
                        .classList.remove("unshow");
                });
        }
    );
}

/** related-products **/
Array.from(document.querySelectorAll(".related-products")).forEach(
    (container) => {
        container
            .querySelector(".slider-button--prev")
            .addEventListener("click", (e) => {
                selectContent(1);
            });
        container
            .querySelector(".slider-button--next")
            .addEventListener("click", (e) => {
                selectContent(-1);
            });
        let itemSelects = Array.from(
            container.querySelectorAll(".product-grid .grid__item")
        );
        let firstLeft = itemSelects[0].offsetLeft;
        let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
        function selectContent(val) {
            let curLeft = container.querySelector(".product-grid").scrollLeft;
            let moveX = (-1 * curLeft) % leftX;

            if (itemSelects != null && itemSelects.length > 1) {
                moveX = (leftX - moveX) * val;
            }
            container.querySelector(".product-grid").scrollLeft = curLeft - moveX;
        }
    }
);
/** related-products **/

/** mt-popular-category **/
Array.from(document.querySelectorAll(".mt-drag-images__container")).forEach(
    (container) => {
        const image = container.querySelector(".mt-drag-images__img");
        const imageBefore = container.querySelector(".mt-drag-images__img1");
        const imageAfter = container.querySelector(".mt-drag-images__img2");
        const handle = document.querySelector(".mt-drag-images__handle");
        let startX, moveX;
        let isDragging = false;
        let initialLeft = 0;

        handle.addEventListener("mousedown", function (e) {
            isDragging = true;
            startX = e.clientX;
        });
        document.addEventListener("mousemove", function (e) {
            if (isDragging) {
                moveX = e.clientX - startX;
                let handleLeft = parseInt(window.getComputedStyle(handle).left, 10);
                let newLeft = handleLeft + moveX;
                let maxLeft = image.offsetWidth - 0;
                let minLeft = 0;
                newLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
                handle.style.left = `${newLeft}px`;
                imageBefore.style.width = `${newLeft}px`;
                imageAfter.style.width = `${image.offsetWidth - newLeft}px`;
                startX = e.clientX;
            }
        });
        document.addEventListener("mouseup", function () {
            isDragging = false;
        });
        handle.addEventListener("touchstart", function (e) {
            isDragging = true;
            startX = e.touches[0].clientX;
        });
        document.addEventListener("touchmove", function (e) {
            if (isDragging) {
                moveX = e.touches[0].clientX - startX;
                let handleLeft = parseInt(window.getComputedStyle(handle).left, 10);
                let newLeft = handleLeft + moveX;
                let maxLeft = image.offsetWidth - 0;
                let minLeft = 0;
                newLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
                handle.style.left = `${newLeft}px`;
                imageBefore.style.width = `${newLeft}px`;
                imageAfter.style.width = `${image.offsetWidth - newLeft}px`;
                startX = e.touches[0].clientX;
            }
        });
        document.addEventListener("touchend", function () {
            isDragging = false;
        });
        document.ondragstart = function (ev) {
            ev.preventDefault();
        };
        document.ondragend = function (ev) {
            ev.preventDefault();
        };
    }
);
/** mt-popular-category **/

/** mt-popular-category **/
function observeElement(el, callback) {
    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    callback(true);
                } else {
                    callback(false);
                }
            });
        },
        {
            root: null,
            threshold: 0.9,
        }
    );

    observer.observe(el);
}
Array.from(
    document.querySelectorAll(".mt-popluar-category__container")
).forEach((container) => {
    observeElement(container, (isVisible) => {
        if (isVisible) {
            container
                .querySelectorAll(".mt-popluar-category__item")
                .forEach((item) => {
                    item.classList.add("selected");
                });
        } else {
            container
                .querySelectorAll(".mt-popluar-category__item")
                .forEach((item) => {
                    item.classList.remove("selected");
                });
        }
    });
});
/** mt-popular-category **/

/** mt-slideshow-reviews **/
Array.from(
    document.querySelectorAll(".mt-slideshow-reviews__container")
).forEach((container) => {
    let dots = container.querySelector(".dots");
    let maxVal = parseInt(dots.getAttribute("data-max-val"));
    let itemSelects = Array.from(
        container.querySelectorAll(".mt-slideshow-reviews__item")
    );
    let images = Array.from(
        container.querySelectorAll(".mt-slideshow-reviews__img")
    );
    if (dots != null && itemSelects != null) {
        Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
            dot.addEventListener("click", (e) => {
                let val = parseInt(e.target.getAttribute("data-val"));
                selectContent(parseInt(val));
            });
        });
        let prevBtn = container.querySelector(".slider-button--prev");
        let nextBtn = container.querySelector(".slider-button--next");
        prevBtn.addEventListener("click", function (e) {
            let curIndex = parseInt(dots.querySelector(".dot.selected").getAttribute("data-val"));
            if (curIndex > 1) {
                selectContent(curIndex - 1);
            }
        });
        nextBtn.addEventListener("click", function (e) {
            let curIndex = parseInt(dots.querySelector(".dot.selected").getAttribute("data-val"));
            if (curIndex < maxVal) {
                selectContent(curIndex + 1);
            }
        });
        let leftX = 0;
        if (itemSelects.length > 1) {
            leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
        }
        function selectContent(val) {
            Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
                if (parseInt(item.getAttribute("data-val")) == val) {
                    item.classList.add("selected");
                } else {
                    item.classList.remove("selected");
                }
            });
            itemSelects.forEach((item) => {
                if (parseInt(item.getAttribute("data-val")) == val) {
                    item.classList.add("selected");
                } else {
                    item.classList.remove("selected");
                }
            });
            images.forEach((item) => {
                if (parseInt(item.getAttribute("data-val")) == val) {
                    item.classList.add("selected");
                } else {
                    item.classList.remove("selected");
                }
            });
            curIndex = val;
        }
    }
});
/** mt-slideshow-reviews **/

/** mt-image-list **/
Array.from(document.querySelectorAll(".mt-image-list__container")).forEach(
    (container) => {
        let dots = container.querySelector(".dots");
        let isDrag = false;
        let itemSelects = Array.from(
            container.querySelectorAll(".mt-image-list__item")
        );
        let items = container.querySelector(".mt-image-list__items");
        if (dots != null && itemSelects != null) {
            let maxVal = parseInt(dots.getAttribute("data-max-val"));
            let maxWidth =
                (itemSelects[0].offsetWidth + 10) * itemSelects.length -
                container.querySelector(".mt-image-list__inner").offsetWidth -
                20;
            let toRight = true;
            // 自动轮播
            let playInterval = setInterval(autoPlay, 10);
            let startX = 0;
            let startY = 0;
            items.addEventListener("touchstart", function (event) {
               clearInterval(playInterval);
               startX = event.touches[0].clientX;
               startY = event.touches[0].clientY;
            });
            items.addEventListener("touchmove", function (event) {
              let curX = event.touches[0].clientX;
              let curY = event.touches[0].clientY;
              let dx = curX - startX;
              let dy = curY - startY;
              if (Math.abs(dx) > Math.abs(dy)) {
                items.scrollLeft = items.scrollLeft -(curX - startX);
              }
            },false);
            items.addEventListener("touchend", function (event) {
                playInterval = setInterval(autoPlay, 10);
            });
            items.addEventListener("mousedown",
                function (event) {
                    event.preventDefault();
                    clearInterval(playInterval);
                    startX = event.clientX;
                },
            false);
            items.addEventListener("mousemove", function (event) {
                event.preventDefault();
                let curX = event.clientX;
                items.scrollLeft = items.scrollLeft - (curX - startX);
            },false);
            items.addEventListener( "mouseup",function (event) {
                    event.preventDefault();
                    playInterval = setInterval(autoPlay, 10);
            },false);

            let firstLeft = 10;
            let leftX = 0;
            if (itemSelects.length > 1) {
                leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
            }
            function selectContent(val) {
                let moveX = 0;
                if (itemSelects != null && itemSelects.length > 1) {
                    moveX = firstLeft - leftX * (val - 1);
                }
                container.querySelector(".mt-image-list__items").scrollLeft = -moveX;
                curIndex = val;
            }
            function autoPlay() {
                if (isDrag == false) {
                    if (
                        container.querySelector(".mt-image-list__items").scrollLeft == 0
                    ) {
                        toRight = true;
                    }
                    if (
                        container.querySelector(".mt-image-list__items").scrollLeft >
                        maxWidth
                    ) {
                        toRight = false;
                    }
                    if (toRight) {
                        container.querySelector(".mt-image-list__items").scrollLeft =
                            container.querySelector(".mt-image-list__items").scrollLeft + 2;
                    } else {
                        container.querySelector(".mt-image-list__items").scrollLeft =
                            container.querySelector(".mt-image-list__items").scrollLeft - 2;
                    }
                }
            }
        }
    }
);
/** mt-image-list **/

/** mt-card-list **/
Array.from(document.querySelectorAll(".mt-card-list__container")).forEach(
    (container) => {
        const progressBar = container.querySelector(".progress-bar");
        const progress = container.querySelector(".progress");
        const itemSelects = Array.from(
            container.querySelectorAll(".mt-card-list__item.mb_show")
        );
        if (itemSelects != null && itemSelects.length > 0 && progressBar != null) {
            const itemWidth = itemSelects[0].offsetWidth + itemSelects[0].offsetLeft;
            const barWidth = progressBar.offsetWidth;
            const maxVal = parseInt(progressBar.getAttribute("data-max-val"));

            function updateDisplay(index) {
                let curIndex = parseInt(progressBar.getAttribute("data-val"));
                curIndex = curIndex + index;
                if (curIndex <= maxVal && curIndex > 0) {
                    const progressWidth = (barWidth * curIndex) / maxVal;
                    progress.style.width = progressWidth + "px";
                    container.querySelector(".mt-card-list__wrapper").scrollLeft = (curIndex - 1) * itemWidth;
                    progressBar.setAttribute("data-val", curIndex);
                }
            }
            progressBar.addEventListener("click", (e) => {
                const rect = progressBar.getBoundingClientRect();
                if (e.clientX - rect.left < progress.offsetWidth) {
                    updateDisplay(-1);
                } else {
                    updateDisplay(1);
                }
            });
            let startX = 0;
            let startY = 0;
            let touchStart = false;
            let curX = 0;
            let curY = 0;
            container.querySelector(".mt-card-list__wrapper").addEventListener("touchstart", function (event) {
                touchStart = true;
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
            });
            container.querySelector(".mt-card-list__wrapper").addEventListener("touchmove", function (event) {
                if (touchStart) {
                    curX = event.touches[0].clientX;
                    curY = event.touches[0].clientY;
                }
            });
            container.querySelector(".mt-card-list__wrapper").addEventListener("touchend", function (event) {
                let dx = curX - startX;
                let dy = curY - startY;
                if (Math.abs(dx) > Math.abs(dy)) {
                    if (curX > startX) {
                        updateDisplay(-1);
                    } else {
                        updateDisplay(1);
                    }
                }
                touchStart = false;
            });
            updateDisplay(1);
        }
    }
);
/** mt-card-list **/

/** mt-product-list **/
Array.from(document.querySelectorAll(".mt-product-list__container")).forEach(
    (container) => {
        const progressBar = container.querySelector(".progress-bar");
        const progress = container.querySelector(".progress");
        const itemSelects = Array.from(
            container.querySelectorAll(".mt-product-list__item")
        );
        if (itemSelects != null && itemSelects.length > 0) {
            const itemWidth = itemSelects[0].offsetWidth + itemSelects[0].offsetLeft;
            const barWidth = progressBar.offsetWidth;
            const maxVal = parseInt(progressBar.getAttribute("data-max-val"));

            function updateDisplay(index) {
                let curIndex = parseInt(progressBar.getAttribute("data-val"));
                curIndex = curIndex + index;
                if (curIndex <= maxVal && curIndex > 0) {
                    const progressWidth = (barWidth * curIndex) / maxVal;
                    progress.style.width = progressWidth + "px";
                    container.querySelector(".mt-product-list__items").scrollLeft = (curIndex - 1) * itemWidth;
                    progressBar.setAttribute("data-val", curIndex);
                }
            }
            progressBar.addEventListener("click", (e) => {
                const rect = progressBar.getBoundingClientRect();
                if (e.clientX - rect.left < progress.offsetWidth) {
                    updateDisplay(-1);
                } else {
                    updateDisplay(1);
                }
            });
            let startX = 0;
            let startY = 0;
            let touchStart = false;
            let curX = 0;
            let curY = 0;
            container.querySelector(".mt-product-list__items").addEventListener("touchstart", function (event) {
                touchStart = true;
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
            });
            container.querySelector(".mt-product-list__items").addEventListener("touchmove", function (event) {
                if (touchStart) {
                    curX = event.touches[0].clientX;
                    curY = event.touches[0].clientY;
                }
            });
            container.querySelector(".mt-product-list__items").addEventListener("touchend", function (event) {
                let dx = curX - startX;
                let dy = curY - startY;
                if (Math.abs(dx) > Math.abs(dy)) {
                    if (curX > startX) {
                        updateDisplay(-1);
                    } else {
                        updateDisplay(1);
                    }
                }
                touchStart = false;
            });
            updateDisplay(1);
        }
    }
);
/** mt-product-list **/


/** mt-slideshow-reviews **/
Array.from(document.querySelectorAll(".mt-slideshow-reviews__container")).forEach(
    (container) => {
        const progressBar = container.querySelector(".progress-bar");
        const progress = container.querySelector(".progress");
        let itemSelects = Array.from(
            container.querySelectorAll(".mt-slideshow-reviews__item")
        );
        let images = Array.from(
            container.querySelectorAll(".mt-slideshow-reviews__img")
        );
        if (itemSelects != null && itemSelects.length > 0) {
            const itemWidth = itemSelects[0].offsetWidth + itemSelects[0].offsetLeft;
            const barWidth = progressBar.offsetWidth;
            const maxVal = parseInt(progressBar.getAttribute("data-max-val"));

            function updateDisplay(index) {
                let curIndex = parseInt(progressBar.getAttribute("data-val"));
                curIndex = curIndex + index;
                if (curIndex <= maxVal && curIndex > 0) {
                    const progressWidth = (barWidth * curIndex) / maxVal;
                    progress.style.width = progressWidth + "px";
                    itemSelects.forEach((item) => {
                        if (parseInt(item.getAttribute("data-val")) == curIndex) {
                            item.classList.add("selected");
                        } else {
                            item.classList.remove("selected");
                        }
                    });
                    images.forEach((item) => {
                        if (parseInt(item.getAttribute("data-val")) == curIndex) {
                            item.classList.add("selected");
                        } else {
                            item.classList.remove("selected");
                        }
                    });
                    progressBar.setAttribute("data-val", curIndex);
                }
            }
            progressBar.addEventListener("click", (e) => {
                const rect = progressBar.getBoundingClientRect();
                if (e.clientX - rect.left < progress.offsetWidth) {
                    updateDisplay(-1);
                } else {
                    updateDisplay(1);
                }
            });
            let startX = 0;
            let startY = 0;
            let touchStart = false;
            let curX = 0;
            let curY = 0;
            container.querySelector(".mt-slideshow-reviews__inner").addEventListener("touchstart", function (event) {
                touchStart = true;
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
            });
            container.querySelector(".mt-slideshow-reviews__inner").addEventListener("touchmove", function (event) {
                if (touchStart) {
                    curX = event.touches[0].clientX;
                    curY = event.touches[0].clientY;
                }
            });
            container.querySelector(".mt-slideshow-reviews__inner").addEventListener("touchend", function (event) {
                let dx = curX - startX;
                let dy = curY - startY;
                if (Math.abs(dx) > Math.abs(dy)) {
                    if (curX > startX) {
                        updateDisplay(-1);
                    } else {
                        updateDisplay(1);
                    }
                }
                touchStart = false;
            });
            updateDisplay(1);
        }
    }
);
/** mt-slideshow-reviews **/